/**
 * Usage Configuration for Bottles
 */

import { supabase } from '../../../../../supabaseClient';

export const usageBottleConfig = {
  type: 'bottles',
  displayName: 'Bottles',
  singularName: 'Bottle',
  itemIdField: 'bottle_id',
  itemNameField: 'name',
  
  // Database tables
  inventoryTable: 'bottle_inventory',
  itemsTable: 'bottle_inventory_items',
  transactionsTable: 'bottle_transactions',
  
  // Get available inventory items for a location
  getInventoryItems: async (companyId, itemId, locationId) => {
    const { data, error } = await supabase
      .from('bottle_inventory_items')
      .select('*')
      .eq('company_id', companyId)
      .eq('bottle_id', itemId)
      .eq('location_id', locationId)
      .eq('is_active', true)
      .gt('current_quantity', 0)
      .order('created_at', { ascending: true });
    
    if (error) throw error;
    return data || [];
  },
  
  // Execute usage transaction
  executeUsage: async (companyId, usageData) => {
    const { locationId, usages, notes } = usageData;
    
    // Process each usage item
    for (const usage of usages) {
      const { itemId, lotId, quantity, lot_number, batch_number } = usage;
      
      // Only create transaction - DB triggers will handle inventory updates
      const { error: txError } = await supabase
        .from('bottle_transactions')
        .insert([{
          company_id: companyId,
          bottle_id: itemId,
          transaction_type: 'usage',
          quantity: -Math.abs(quantity), // Negative for usage
          location_id: locationId,
          lot_number: lot_number,
          batch_number: batch_number,
          transaction_date: new Date().toISOString(),
          notes: notes || null,
          delivery_status: 'delivered'
        }]);
      
      if (txError) throw txError;
    }
  }
};
